// import Profile from './Profile';

export default {
  priority: 10,
  exact: true,
  path: 'profile',
  permissions: [],
  // component: Profile,
  component: load(() => import(/* webpackChunkName: "Profile" */ './Profile')),
  name: app.translate('routes.home.profile.Profile'),
  icon: 'account',
  drawer: false,
};
